import React, {useEffect} from "react";
import ImageList from "~/apps/cartario/components/ImageList.tsx";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "~/store";
import {fetchThemeFiles, updateThemeFile} from "~/store/shopifySlice.ts";
import {Box, Button, Input, Text, useToast} from "@chakra-ui/react";

const ThemeImages: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const theme = useSelector((state: any) => state.shopify.theme);
    const toast = useToast();

    useEffect(() => {
        dispatch(fetchThemeFiles());
    }, [dispatch]);


    const handleUploadImages = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if(!files || files.length === 0) {
            toast({
                title: "No files selected",
                status: "warning",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        // Create FormData and add files
        const formData = new FormData();
        Array.from(files).forEach(file => {
            formData.append('files', file);
            console.log(`Adding file to FormData: ${file.name} (${file.size} bytes)`);
        });

        // Log FormData contents for debugging
        console.log("FormData entries:");
        for (let pair of formData.entries()) {
            console.log(pair[0], typeof pair[1], pair[1]);
        }

        // Dispatch the upload action
        dispatch(updateThemeFile({
            formData,
            galleryId: theme.public_id
        }))
            .unwrap()
            .then((theme_data) => {
                if(theme_data?.error) {
                    toast({
                        title: "Error uploading files",
                        description: theme_data.error,
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                } else {
                    dispatch(fetchThemeFiles());
                    toast({
                        title: "Images uploaded successfully",
                        status: "success",
                        duration: 3000,
                        isClosable: true,
                    });
                }
            })
            .catch(error => {
                console.error("Upload failed:", error);
                toast({
                    title: "Upload failed",
                    description: "There was an error processing your request",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            });
    };

    return (
        <>
            <Text as="h1" mb={4}>
                {theme.name} Theme Images
            </Text>
            <Text as="p" mb={3} pl={1}>
                This is a custom gallery of images for the {theme.name} theme. You can download any theme image from your
                store and upload them here.
            </Text>
            <Text as="p" pl={1}>
                Once uploaded you will be able to edit them or generate new images that you can download and re-upload to your theme.
            </Text>

            <Box textAlign="right" mt={4} mb={4}>
                <Input
                    type="file"
                    multiple
                    onChange={handleUploadImages}
                    display="none"
                    id="upload-images"
                    accept="image/*"
                />
                <Button
                    as="label"
                    htmlFor="upload-images"
                    colorScheme="blue"
                    disabled={false}
                >
                    Upload Images
                </Button>
            </Box>

            {theme?.images?.length > 0 && (
                <ImageList type="theme" images={theme.images} />
            )}

            {!theme?.images?.length && (
                <Box mt={4} mb={4} p={1}>
                    Currnetly there are no images in this theme gallery. Please upload some images to get started.
                </Box>
            )}

        </>
    )
};

export default ThemeImages;
